// extracted by mini-css-extract-plugin
export default {"root":"MainScreen_root__2XTLb","header":"MainScreen_header__4B5h9","count":"MainScreen_count__FHA0W","tip":"MainScreen_tip__TMBd2","alertMsg":"MainScreen_alertMsg__ONxtE"};